import { consoleApiSlice } from "./consoleApiSlice";

// V2 finding-status overlay for the Staging/Prod Agents tabs. Discards live in
// the platform V2 findings table (linked to V1 issues via source_issue_id), so
// V1 issues alone don't reflect them. Returns { statuses: { issueId: status } }.
export const platformFindingsApiSlice = consoleApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getFindingStatusesByScanId: builder.query({
      query: ({ scanId, env = "staging" }) => ({
        url: `/platform-findings/scan/${scanId}`,
        params: { env },
      }),
      providesTags: (result, error, { scanId }) => [
        { type: "Issues", id: `findings:${scanId}` },
      ],
    }),
  }),
});

export const {
  useGetFindingStatusesByScanIdQuery,
  useLazyGetFindingStatusesByScanIdQuery,
} = platformFindingsApiSlice;
